import * as React from "react";
import { Dialog, Slide, Grid, IconButton, makeStyles } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import Image from "next/image";
import AgapeButton from "../button/AgapeButton";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const useStyles = makeStyles((theme) => ({
  closeIcon: {
    fontSize: "1.818rem",
  },
  root: {
    width: "100%",
    height: "100%",
  },
  container: {
    width: "100%",
    [theme.breakpoints.up("md")]: {
      minWidth: "600px",
      minHeight: "200px",
    },
  },
  Typography1: {
    fontSize: "1.818rem",
    fontFamily: "Vazir-Bold",
  },
  header: {
    // backgroundColor: 'red',
  },
  padding: {
    padding: "20px 10px",
  },
  paddingLight: {
    padding: "10px 10px",
  },
  closeContainer: {
    textAlign: "right",
  },
  row: {
    backgroundColor: "#ffffff",
    "& *": {
      fontSize: "2.181rem",
    },
  },
  headerItems: {
    "& *": {
      fontFamily: "Vazir-Light",
      fontSize: "1.454rem",
      color: "#8898aa",
    },
  },
  alert: {
    // marginBottom: '40px',
    width: "1100px",
    height: "600px",
    overflowY: "auto",
    "&::-webkit-scrollbar": {
      width: "14px",
      height: "18px",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffffff",
    },
    "&::-webkit-scrollbar-thumb": {
      height: "6px",
      border: "4px solid rgba(0, 0, 0, 0)",
      backgroundClip: "padding-box",
      backgroundColor: "#8898aa",
    },
    "&::-webkit-scrollbar-thumb:hover": {
      backgroundColor: "#525b67",
    },
    "& img": {
      width: "100%",
    },
  },
  alert2: {
    // marginBottom: '40px',
    width: "1100px",
    height: "700px",
    overflowY: "auto",
    "&::-webkit-scrollbar": {
      width: "14px",
      height: "18px",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffffff",
    },
    "&::-webkit-scrollbar-thumb": {
      height: "6px",
      border: "4px solid rgba(0, 0, 0, 0)",
      backgroundClip: "padding-box",
      backgroundColor: "#8898aa",
    },
    "&::-webkit-scrollbar-thumb:hover": {
      backgroundColor: "#525b67",
    },
    "& img": {
      width: "100%",
    },
    "@media only screen and (max-width: 600px)": {
      height: "250px",

    },
  },
  typoBody: {
    color: "#8898aa",
  },
  acceptBtn: {
    textAlign: "center",
    width:"100%",
    margin: "20px 0",
    fontFamily: "Vazir-Bold",
    fontSize: "1.272rem",
    padding: "8px 10px !important",
    "&:hover": {
      backgroundColor: theme.palette.primary.main,
    },
    "@media only screen and (max-width: 600px)": {
      width:"290px",


    },
  },
  downloadBtn: {
    textAlign: "center",
    margin: "20px 0",
    fontFamily: "Vazir-Bold",
    fontSize: "1.272rem",
    padding: "8px 10px !important",
    backgroundColor: theme.palette.primary.light,
    "&:hover": {
      backgroundColor: theme.palette.primary.light,
    },
    "& a": {
      color: "white",
    },
  },
  btnsRow: {
    padding: "0 10px",
  },
  imgfile: {
    width: "100%",
    height: "100%",
  },
}));
const FileDialog = ({ file, open, setOpen }) => {
  const classes = useStyles();

  const handleClose = () => {
    setOpen(false);
  };

  const handleClick = () => {
    setOpen(false);
  };

  React.useEffect(() => {
    if (open) {
      document
        .getElementById("noRightClickDialog")
        ?.addEventListener("contextmenu", (e) => {
          e.preventDefault();
        });
      setTimeout(() => {
        document
          .getElementById("noRightClickDialog")
          ?.addEventListener("contextmenu", (e) => {
            e.preventDefault();
          });
      }, 500);
    }
  }, [open]);
  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      scroll="paper"
      maxWidth="xl"
      onClose={handleClose}
      className={classes.root}
    >
      <Grid container className={classes.container}>
        <Grid item container md={12} justify="flex-end">
          <IconButton onClick={handleClose}>
            <CloseIcon className={classes.closeIcon} />
          </IconButton>
        </Grid>
        {file &&
          (file.endsWith && file.endsWith(".pdf") ? (
            // <Typography>نمایش در دسترس نیست</Typography>
            // <embed src={file} width="800px" height="2100px" />
            <Grid
              item
              container
              md={12}
              justify="center"
              className={classes.alert}
            >
              <iframe
                title="pdf"
                src={file}
                style={{ width: "1100px", height: "600px" }}
              />
            </Grid>
          ) : (
            <Grid
              item
              container
              md={12}
              justify="center"
              className={classes.alert2}
            >
              <Image
                placeholder="blur"
                // width={1000}
                // height={200}
                // width={0}
                // height={0}
                src={file}
                alt="test"
                blurDataURL={file}
                id="noRightClickDialog"
                // className={classes.imgfile}
                layout="fill"
                sizes="(max-width:768px) 50vw , (max-width:1200px) 50vw, 53vw"
              />
            </Grid>
          ))}

        <Grid
          item
          container
          justify="space-between"
          md={12}
          className={classes.btnsRow}
        >
          {/* <Grid item md={3}>
            <AgapeButton
              variant="contained"
              disableRipple
              disableElevation
              disableFocusRipple
              disableTouchRipple
              fullWidth
              backgroundColor="primary"
              onClick={handleDownload}
              customClassName={classes.downloadBtn}
            >
              <a target="_blank" rel="noreferrer" href={file} download>
                دانلود فایل
              </a>
            </AgapeButton>
          </Grid> */}
          <Grid item md={12}>
            <AgapeButton
              variant="contained"
              disableRipple
              disableElevation
              disableFocusRipple
              disableTouchRipple
              fullWidth
              backgroundColor="primary"
              onClick={handleClick}
              customClassName={classes.acceptBtn}
            >
              تایید
            </AgapeButton>
          </Grid>
        </Grid>
      </Grid>
    </Dialog>
  );
};

export default FileDialog;
